import { organisationPaths } from 'src/routes/employer/paths/organisation.paths';
import { BreadcrumbLink } from '../../../../shared/components/breadcrumbs/BreadcrumbLink';

export const OrganisationDetailsBreadcrumb = (): React.ReactElement<any, any> | null => (
    <BreadcrumbLink to={organisationPaths.details}>Organisation</BreadcrumbLink>
);
